export const isNil = <T>(
  value: T | null | undefined
): value is null | undefined => value === null || value === undefined;

type IterateeType<T, K> = (item: T) => K;
type ArrayFunctionType = <T>(array: T[] | null | undefined) => T[];
type ArrayFunctionDynamicType<T> = (array: T[] | null | undefined) => T[];

export const uniqBy =
  <T, K>(iteratee: IterateeType<T, K>): ArrayFunctionDynamicType<T> =>
  (array) => {
    if (isNil(array)) {
      return [];
    }

    const uniqueValues: T[] = [];
    const seenKeys: K[] = [];

    for (const item of array) {
      const key = iteratee(item);
      if (!seenKeys.includes(key)) {
        seenKeys.push(key);
        uniqueValues.push(item);
      }
    }

    return uniqueValues;
  };

export const identity = <T>(value: T): T => value;

export const uniq: ArrayFunctionType = (array) => {
  return uniqBy(identity)(array);
};

export const compact: ArrayFunctionType = (array) => {
  if (isNil(array)) {
    return [];
  }
  return array.filter(Boolean);
};

type ObjectKeysParamsType = Parameters<typeof Object.keys>[0];

export const keys = (
  obj: ObjectKeysParamsType | undefined | null
): string[] => {
  if (isNil(obj)) {
    return [];
  }
  return Object.keys(obj);
};
